export class PaymentRequestModel {
    FacilityName?: string;
    ServiceName?: string;
    CreatedDate?: string;
    Username: string;
    PID: number; //PaymentRequestID
    Amount: number;
}